<template>
  <div class="post-wrapper">
    <div v-for="(post, index) in data" :key="index" :index="post.id" class="card card-default border mb-3"
      data-social="item" style="width: 100%; border-radius: 10px">
      <div class="card-body" style="cursor: text !important" @mouseleave="hideFullContent">
        <div class="row post-content">
          <div class="col-md-1 col-xs-12" align="center">
            <div class="user-pic">
              <img alt="Profile Image" :data-src-retina="post | showPicture" :data-src="post | showPicture"
                :src="post | showPicture" class="img-circle" @error="imageUrlAlt" />
            </div>
          </div>
          <div class="col-md-11">
            <div class="d-flex">
              <div class="account-name h6 clickable hoverable" style="cursor: pointer !important;width: 75%"
                @click="showAccount(post)">
                <span v-if="post.source === 'twitter'">@</span>
                {{
                  post.source == "media_cetak" ||
                  post.source == "media_tv" ||
                  post.source == "youtube" ||
                  post.source == "news"
                  ? post.title
                  : post.account
                }}
              </div>
              <div class="ml-auto fs-12 d-flex" style="width: 25%">
                <i class="bi bi-calendar-event ml-auto mr-1"></i>
                {{ dateindo(post.date.$date) }}
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="d-flex align-items-center p-t-5">
              <div v-if="sosmed_list.includes(post.source)" class="engagement-detail">
                <span v-for="(engagement, e_index) in post.engagement_detail" :key="e_index"
                  :title="post_attribute[e_index]" class="m-r-5 post-number">
                  <i :class="post_meta[e_index]"></i> {{ engagement }}
                </span>

                <span class="separator">|</span>

                <span class="m-l-5 post-number" title="Jangkuan">
                  <i class="bi bi-megaphone"></i> {{ post.esmr | kmbFormatter }}
                </span>

                <span class="m-r-10 m-l-5 post-number" title="Keterlibatan">
                  <i class="bi bi-share-fill"></i>
                  {{ post.engagement_count | kmbFormatter }}
                </span>
              </div>

              <span v-if="!sosmed_list.includes(post.source) &&
                post.source != 'media_tv' &&
                post.source != 'media_cetak'
                " @click="showAccount(post)" class="m-r-10 post-number clickable hoverable" title="Sumber">
                <i class="bi bi-globe-americas"></i>
                {{ post.account ? post.account : "Tidak Tercantum" }}
              </span>

              <span v-if="post.source == 'media_cetak'" class="m-r-10 post-number clickable hoverable"
                title="Sumber Media Cetak" @click="showAccount(post)">
                <i class="bi bi-newspaper"></i>
                {{ post.account ? post.account : "Tidak Tercantum" }}
              </span>

              <span v-if="post.source == 'media_tv'" class="m-r-10 post-number clickable hoverable"
                title="Channel TV - Nama Program" @click="showAccount(post)">
                <i class="bi bi-tv"></i>
                {{ post.account ? post.account : "Tidak Tercantum" }} -
                {{ post.program ? post.program : "Tidak Tercantum" }}
              </span>

              <span v-if="post.source == 'media_cetak' || post.source == 'media_tv'" class="m-r-10 post-number"
                title="Jurnalis">
                <i class="bi bi-person"></i>
                {{ post.journalist ? post.journalist : "Tidak Tercantum" }}
              </span>

              <span v-if="post.source == 'news' && post.author" class="m-r-10 post-number" title="Jurnalis">
                <i class="bi bi-person"></i>
                {{ post.author ? post.author : "Tidak Tercantum" }}
              </span>

              <span v-if="post.source == 'media_cetak' || post.source == 'media_tv'" class="m-r-10 post-number"
                title="Nilai Iklan">
                <b>AD</b> IDR
                {{
                  post.rate_fc > 0 && post.rate_fc > 0
                  ? post.rate_fc
                  : post.rate_fc > 0 && post.rate_bw == 0
                    ? post.rate_fc
                    : post.rate_fc == 0 && post.rate_bw > 0
                      ? post.rate_bw
                      : 0 | kmbFormatter
                }}
              </span>
              <span v-if="post.source == 'news'" class="m-r-10 post-number" title="Nilai Iklan">
                <b>AD</b> IDR {{ post.ad_value | kmbFormatter }}
              </span>
              <span v-if="post.source == 'media_cetak' ||
                post.source == 'media_tv' ||
                post.source == 'news'
                " class="m-r-10 post-number" title="Nilai Hubungan Masyarakat">
                <b>PR</b> IDR {{ post.pr_value | kmbFormatter }}
              </span>
              <span v-if="cekPers(post.id_account)" class="bg-orange label text-white fs-10 m-r-10">
                Pers
              </span>
              <div v-if="post.sentiment === 1" class="m-r-10">
                <span class="label label-success">Positif</span>
              </div>
              <div v-else-if="post.sentiment === -1" class="m-r-10">
                <span class="label label-danger">Negatif</span>
              </div>
              <div v-else class="m-r-10">
                <span class="label label-netral">Netral</span>
              </div>

              <!-- hoax -->
              <div v-if="post.hoax === 1" class="m-r-10">
                <span class="label label-success">Fakta</span>
              </div>
              <div v-else-if="post.hoax === -1" class="m-r-10">
                <span class="label label-danger">Hoax</span>
              </div>
              <div v-else-if="post.hoax === 2" class="m-r-10">
                <span class="label label-inverse">Opini</span>
              </div>
              <!-- <div v-else class="m-r-10"> -->
                <!-- <span class="label label-warning">Tidak Diketahui</span> -->
              <!-- </div> -->

              <span class="bg-default label p-t-1 p-b-1 fs-10 m-1 mb-1" v-if="post.botscore != null" title="Bot Skor" :class="getBadgeClass(post.botscore)">BS : {{ (post.botscore * 100) }}%</span>

              <span v-if="post.highlight" class="post-number m-r-10" title="Serupa dengan posting di highlight">
                <i class="bi bi-star-fill" style="color: #ffc107"></i>
              </span>
              <span v-if="post.source != 'news' &&
                post.source != 'media_cetak' &&
                post.source != 'media_tv'
                " :id="'actual-emotion-' + index" class="post-number">
                <i v-if="post.emotion == 0" class="bi bi-emoji-neutral" style="font-size: 16px" title="Netral"></i>
                <i v-if="post.emotion == 1" class="bi bi-emoji-smile text-success" style="font-size: 16px"
                  title="Senang"></i>
                <i v-if="post.emotion == 2" class="bi bi-emoji-dizzy text-warning" style="font-size: 16px"
                  title="Takut"></i>
                <i v-if="post.emotion == 3" class="bi bi-emoji-frown text-blue" style="font-size: 16px" title="Sedih"></i>
                <i v-if="post.emotion == 4" class="bi bi-emoji-angry text-danger" style="font-size: 16px"
                  title="Marah"></i>
              </span>
            </div>
            <p class="post-text-content text-justify">
              <span class="text-content" v-html="writeContent(post.content)"></span>
              <a href="javascript:void(0)" v-if="cekString(post.content)" @click="showFullContent($event, index)">
                Selengkapnya
              </a>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <div class="d-flex align-items-center mt-3">
              <span v-if="show_topik">
                Topik :
                <div v-for="(t, tIndex) in post.topics" :key="tIndex"
                  class="btn btn-xs btn-rounded btn-default fs-10 m-r-5">
                  <span>{{ showTopicName(t.$oid) }}</span>
                </div>
              </span>
              <a v-if="post.source == 'media_cetak' || post.source == 'media_tv'"
                class="text-success ml-auto clickable hoverable" href="javascript:void(0)" @click="showSumber(index)"
                style="opacity: 1">
                <i class="bi bi-eye"></i> Lihat Sumber
              </a>
              <a v-else class="ml-auto text-blue clickable hoverable" :href="post.url" target="__blank">
                <i class="bi bi-box-arrow-up-right"></i> Kunjungi
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-dynamic-component v-if="show_modal_sumber" :key="modal_sumber_key" modal_id="modal_sumber"
      :modal="modal_sumber" :data="modal_sumber_data" />
  </div>
</template>

<script>
import $ from "jquery";
import gp from "@/plugins/generalPlugins.js";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_sumber_body from "@/views/components/mention/modal_sumber.vue";

var sosmed_icon = new Array();
sosmed_icon["facebook"] = "bi bi-facebook";
sosmed_icon["twitter"] = "bi bi-twitter-x";
sosmed_icon["youtube"] = "bi bi-youtube";
sosmed_icon["instagram"] = "bi bi-instagram";
sosmed_icon["news"] = "bi bi-globe-americas";
sosmed_icon["blog"] = "bi bi-rss";
sosmed_icon["forum"] = "bi bi-chat-dots-fill";
sosmed_icon["media_cetak"] = "bi bi-newspaper";
sosmed_icon["media_tv"] = "bi bi-tv";
sosmed_icon["linkedin"] = "bi bi-linkedin";
sosmed_icon["tiktok"] = "bi bi-tiktok";

var post_meta = [];
post_meta["comment"] = "bi bi-chat-fill";
post_meta["rt"] = "bi bi-repeat";
post_meta["share"] = "bi bi-share";
post_meta["like"] = "bi bi-heart-fill";
post_meta["fav"] = "bi bi-heart-fill";

var post_attribute = [];
post_attribute["fav"] = "Disukai";
post_attribute["like"] = "Disukai";
post_attribute["rt"] = "Retweet";
post_attribute["share"] = "Bagikan";
post_attribute["comment"] = "Komentar";

export default {
  name: "post_list_simple",
  components: {
    "modal-dynamic-component": modal_dynamic,
  },
  props: {
    posts: Array,
    keyword: Array,
    is_title_clicked: {
      type: Boolean,
      default: function () {
        return true;
      },
    },
    string_limit: {
      type: Number,
      default: function () {
        return 200;
      },
    },
    show_topik: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    topics: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      data: this.posts,
      pers: null,
      stringLimit: this.string_limit,
      sosmed_icon: sosmed_icon,
      post_meta: post_meta,
      sosmed_list: [
        "facebook",
        "instagram",
        "twitter",
        "youtube",
        "tiktok",
        "linkedin",
        "forum",
        "blog",
        "review",
      ],
      post_attribute: post_attribute,
      modal_sumber: null,
      modal_sumber_data: null,
      modal_sumber_key: 10,
      show_modal_sumber: false,
      modal_sumber_body: modal_sumber_body,
    };
  },
  methods: {
    getBadgeClass(score) {
        if (score <= 0.25) {
            return 'bg-green'; // Class for botscore < 25
        } else if (score >= 0.26 && score <= 0.50) {
            return 'bg-yellow'; // Class for botscore between 25 and 50
        } else if (score >= 0.51 && score <= 0.75) {
            return 'bg-orange'; // Class for botscore between 51 and 75
        } else {
            return 'bg-red'; // Class for botscore > 75
        }
    },
    showAccount(post) {
      let account = post;
      if (this.is_title_clicked) {
        this.$router.push({
          path: "/detail-akun",
          query: { account: account.account, key: btoa(account.id_account) },
        });
      }
    },
    dateindo: function (tanggal) {
      return gp.dateTimeID(tanggal);
    },
    showFullContent: function (event, index) {
      var contentEl = $(event.target).prev();
      var text = $(event.target)
        .prev()
        .text();
      if (text.length <= this.stringLimit) {
        text = this.data[index].content;
        $(event.target).html(" Sembunyikan");
      } else {
        text = this.data[index].content.substring(0, this.stringLimit);
        $(event.target).html(" Selengkapnya");
      }
      contentEl.html(text);
    },
    showTopicName: function (_id) {
      if (this.topics != null) {
        for (let grup in this.topics.formed) {
          for (let topic in this.topics.formed[grup].topics) {
            if (_id == topic) {
              return this.topics.formed[grup].topics[topic];
            }
          }
        }
        if (_id in this.topics.socmed) {
          return this.topics.socmed[_id];
        } else {
          return false;
        }
      } else {
        return "-";
      }
    },
    hideFullContent: function (event) {
      var post_text_content = $(event.target).find(".post-text-content");
      post_text_content.css("-webkit-line-clamp", "2");
    },
    cekPers: function (_id) {
      if (this.pers != null) {
        return this.pers.includes(_id);
      } else {
        return false;
      }
    },
    cekString: function (text) {
      if (text.length > this.stringLimit) {
        return true;
      } else {
        return false;
      }
    },
    writeContent: function (text) {
      var newText = text.substring(0, this.stringLimit);
      return newText;
    },
    imageUrlAlt: function () {
      event.target.src = "/assets/img/profiles/default.png";
    },
    showSumber: function (index) {
      this.modal_sumber = {
        title: "Sumber Data",
        subtitle: "",
        component: this.modal_sumber_body,
      };
      this.modal_sumber_data = [this.data[index]];
      this.modal_sumber_key++;
      this.show_modal_sumber = true;
    },
    autoHighlight() {
      for (let i in this.posts) {
        let text = this.posts[i].content;
        this.posts[i].content = this.markString(text, this.keyword);
      }
    },
    markString: function (content, marked_word = []) {
      let kata = [];
      if (marked_word.length > 0) {
        marked_word.forEach((word) => {
          word = gp.extractPhrase(word);
          if (
            word.every((w) => content.toLowerCase().includes(w.toLowerCase()))
          ) {
            word.forEach((w) => {
              w = w.trim();
              kata.push(w);
            });
          }
        });
      }
      kata = [...new Set(kata)];
      kata.forEach(function (word) {
        word = word.replaceAll('"', "");
        word = word.trim();
        let reg_exp = new RegExp("(\\b" + word + "\\b)", "gi");
        content = content.replace(
          reg_exp,
          ` <mark data-markjs="true"> ${word}  </mark> `
        );
      });
      return content;
    },
  },
  filters: {
    showPicture: function (post) {
      let pro_pic;
      switch (post.source) {
        case "twitter":
          pro_pic = post.profile_image;
          break;
        case "instagram":
          pro_pic = post.profile_image;
          break;
        case "facebook":
          pro_pic = post.profile_photo;
          break;
        default:
          pro_pic = "/assets/img/profiles/default.png";
          break;
      }

      if (pro_pic == null) {
        pro_pic = "/assets/img/profiles/default.png";
      }
      return pro_pic;
    },
    kmbFormatter: function (number) {
      return gp.kmbFormatter(number);
    },
  },
  mounted: function () {
    this.autoHighlight();
    let self = this;
    $(".post-wrapper").on("#modal_sumber hidden.bs.modal", function () {
      self.show_modal_sumber = false;
    });
  },
};
</script>

<style scoped>
.img-circle {
  height: auto !important;
  width: 100% !important;
  border-radius: 50%;
  border: 3px #eee solid;
  max-height: 60px;
  max-width: 60px;
}

@import "/assets/plugins/bootstrap-social/bootstrap-social.css";

.user-pic {
  width: 100% !important;
  height: auto !important;
  position: relative;
}

.img-circle {
  height: auto !important;
  width: 100% !important;
  border-radius: 50%;
  border: 2px #ccc solid;
  max-height: 60px;
  max-width: 60px;
}

.label-netral {
  background-color: #0e6d87;
  color: white;
}

.post-content:hover .post-number {
  color: black;
  opacity: 1 !important;
}

#action-tersembunyi {
  display: none;
}
.bg-green {
  background-color: rgb(18, 255, 18);
  color:#000000 !important;
}

.bg-yellow {
  background-color: yellow;
  color:#000000 !important;
}

.bg-orange {
  background-color: rgb(255, 196, 88);
  color:#000000 !important;
}

.bg-red {
  background-color: rgb(255, 72, 72);
  color:#000000 !important;
}
</style>
